export default "__VITE_ASSET__DTV$qtCy__"